const state = {
    isCollapse: false,
    myAppraiseActiveTab: '',
    teamAppraiseActiveTab: '',
    language: '',
    oaTitle: '',
    userInfo: {
        
    },
    menus: [],
    menuList: [],
    roles: [],
    currentRole:{},
    currentModule: '',
    defaultActive: '',
    redirectUrl: '',
}

export default state